import Archive from "@mui/icons-material/Archive";
import { Button } from "@mui/material";
import { JobStatus } from "generated-graphql/graphql";
import { useState } from "react";

import { ArchivePipelineRunDialog } from "./ArchivePipelineRunDialog";
import { canArchivePipelineRun } from "./pipelineUtils";

/** Header action on the run results page; hidden once the run can't be archived. */
export function ArchivePipelineRunButton({
  pipeline,
}: {
  pipeline:
    | {
        id: string;
        archivedAt?: string | null;
        ingestedAt?: string | null;
        ingestionJob?: { status: JobStatus } | null;
      }
    | null
    | undefined;
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  if (!pipeline || !canArchivePipelineRun(pipeline)) return null;

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Archive />}
        onClick={() => setConfirmOpen(true)}
        sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
      >
        Archive
      </Button>
      {confirmOpen && (
        <ArchivePipelineRunDialog
          pipelineId={pipeline.id}
          refetchQueries={["WastePipelineRunMetadata"]}
          onClose={() => setConfirmOpen(false)}
        />
      )}
    </>
  );
}
